module.exports = __webpack_public_path__ + "img/newsImg.2998c527.png";